fx.ns("desktop.common.behaviour", class Move extends shared.Behaviour{

    constructor(mouse, guidelines, model)
    {    
        super(mouse, "move");  
        
        this.guidelines = guidelines;
        this.model = model
    }

    
    start(event)
    {
        super.start();

        if (!event.element || !event.element.movable)
            return;

        this.element = event.element;
        this.area = event.area;
        this.targetRotation = this.element.data.rotation;//this.element.SVGElement.transform('rotation');
        this.originalOffset = {   
                                offsetX : event.originalEvent.pageX / ( this.area.scale * this.model.zoom.realValue) - (this.element.x),
                                offsetY : event.originalEvent.pageY / (this.area.scale  * this.model.zoom.realValue) - (this.element.y)
        };

        this.anchor = fx.dom.parent(event.originalEvent.target, ".anchor");
        
        if (this.guidelines)
            this.guidelines.start(this.element, this.area);

        this.element.moveStart();
    }

    action(event)
    {
        super.action();

        if (!this.element || !this.element.movable)
            return;

        event.originalEvent.preventDefault();

        if (!this.area || !this.element.data)
            return;

        let rawTop = (event.originalEvent.pageY / (this.area.scale *  this.model.zoom.realValue) - this.originalOffset.offsetY);
        let rawLeft = (event.originalEvent.pageX  / (this.area.scale  *  this.model.zoom.realValue) - this.originalOffset.offsetX);

        let top = rawTop; 
        let left = rawLeft;
        
        if (fx.get("settings").gridmode)
        {
            top = top.multipleOf( fx.get("settings").precision );
            left = left.multipleOf( fx.get("settings").precision );
        }

        let coordinates = {top : top, left : left};
        if (this.element.lockOnlostBorder)
            coordinates = this.lockOnLostBorderCoordinates( left, top, this.targetRotation);
        else
        if (this.element.avoidlostBorder)
            coordinates = this.avoidLostBorderCoordinates( left, top, this.targetRotation);

        left = coordinates.left;
        top = coordinates.top;

        if (this.guidelines)
            this.guidelines.check(left, top, this.element.width, this.element.height, this.element.rotation ,this.element);

        this.element.move(left, top, this.targetRotation, null);
    }

    end(event)
    {
        super.end();

        if (!this.element || !this.element.movable)
            return;

        if (this.guidelines)
            this.guidelines.stop();

        if (!this.element)
            return;

        this.element.moveEnd();

        this.element = null;
        this.area = null;
        this.targetRotation = null;
        this.originalOffset = null;

        event.originalEvent.preventDefault();

    }

    
});